export default __webpack_public_path__ + "static/media/DinosaurTrain_01.65f0f8c2.png";